import { AccountManagementPageTestsSection } from './AccountManagementPageTestsSection';
import { AccountManagementPageStudiesSection } from './AccountManagementPageStudiesSection';
import { AccountManagementPageProfileSection } from './AccountManagementPageProfileSection';
import { AccountManagementPageSubscriptionSection } from './AccountManagementPageSubscriptionSection';
import { AccountManagementPageOrderTrackingSection } from './AccountManagementPageOrderTrackingSection';
import { SettingsPageSupportSection } from '../SettingsPage/SettingsPageSupportSection';
import { useState } from 'react';
import { Button } from '@design-system/Button';
import { useNavigate } from 'react-router-dom';
import { SETTINGS_PATH } from '@/constants/paths';

export type AccountManagementPageProps = React.ComponentProps<'div'> & {};

export const AccountManagementPage = () => {
  // Hide the studies and VIE chat section as it not required for web
  const [hideStudiesSection] = useState(false);
  const navigate = useNavigate();

  return (
    <section className="page-container flex flex-col gap-12" data-testid="accountManagement-page">
      <AccountManagementPageProfileSection className="mb-5" data-testid="accountManagement-profileSection" />

      <AccountManagementPageSubscriptionSection />

      <AccountManagementPageOrderTrackingSection />

      <AccountManagementPageTestsSection />

      {hideStudiesSection && (
        <AccountManagementPageStudiesSection />
      )}

      <SettingsPageSupportSection data-testid="accountManagement-supportSection" />

      <Button
        className="justify-center mb-5"
        onClick={() => navigate(SETTINGS_PATH)}
        data-testid="accountManagement-accountSettingsButton"
      >
        Account Settings
      </Button>
    </section>
  );
};
